
/**
 * Module dependencies.
 */

import { ReactNode, createContext, useContext } from 'react';
import { resolveImageSize } from '../media';

/**
 * `Props` type.
 */

type Props = {
  children: ReactNode;
};

/**
 * `ImageSizeResolver` type.
 */

type ImageSizeResolver = (imageUrl: string | null | undefined, size: string) => string | null | undefined;

/**
 * Image size resolver context.
 */

const ImageSizeResolverContext = createContext<ImageSizeResolver>((url: any) => url);

/**
 * Export `useImageSizeResolver`.
 */

export function useImageSizeResolver() {
  return useContext(ImageSizeResolverContext);
}

/**
 * Export `ImageSizeResolverProvider`.
 */

export function ImageSizeResolverProvider({ children }: Props): JSX.Element {
  return (
    <ImageSizeResolverContext.Provider value={resolveImageSize}>
      {children}
    </ImageSizeResolverContext.Provider>
  );
}
